<template>
  <div class="item3">
    <div class="name-date">
      <!-- <div class="name">{{item.plan_name}}</div> -->
      <div class="name">水杯编号: {{item.plan_name}}</div>
      <div class="date">{{item.create_time}}</div>
    </div>
    <div class="price">
      <span class="label">退还金额</span>
      <span class="wechatNumber">{{item.money}}</span>
    </div>
    <div class="reason">拒绝原因：{{item.review_remark}}</div>
  </div>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    }
  }
</script>

<style lang="less" scoped>
  .item3 {
    .bg(#fff);
    .br(.1rem);
    .p(.28rem .3rem);
    .mb(.24rem);
    .name-date {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .mb(.28rem);
      .name {
        .fz(.28rem);
        .c(#333);
        // font-weight: bold;
      }
      .date {
        .fz(.24rem);
        .c(#999);
      }
    }
    .price {
      .fz(.24rem);
      .c(#999);
      .mb(.28rem);
      .wechatNumber {
        .fz(.28rem);
        .c(#00b0f4);
        .ml(.3rem);
      }
    }
    .reason {
      .fz(.26rem);
      .c(#ff2c4c);
      border-top: 1px solid #e5e5e5;
      .pt(.24rem);
    }
  }
</style>
